import React from 'react'
import { Image } from 'react-bootstrap';
import {
    DifferenceBanner,
    DonationDifferenceTitle,
    MakeDifference,
    DonationMake, 
    DonationImage,
    DonationTitle,
    DonationText,
    DonationTextCol,
} from './donationDifferenceStyle'
import DonationOne from '../../../assests/images/donationone.webp';
import { MESSAGE } from '../../../utils/message';

const DonationDifference = ({data}:any) => {
  return (
    <DifferenceBanner> 
      <DonationDifferenceTitle className='donation-title'>{MESSAGE.donationMakeDifference}</DonationDifferenceTitle>
        <MakeDifference>
          {data?.map((donation:any,index:number) => (
            <DonationMake key={index+1}>
              <DonationImage><Image src={DonationOne} alt={donation.donationImg}/></DonationImage>
              <DonationTextCol>
                  <DonationTitle className='dollar-dollar-title'>{donation.donationTitle}</DonationTitle>
                  <DonationText>{donation.donationDesc}</DonationText>
              </DonationTextCol>
            </DonationMake> 
          ))}
        </MakeDifference>
    </DifferenceBanner>
  )
}

export default DonationDifference
